<div class="d-flex justify-content-center align-items-center vh-100">
  <form class="card p-4" style="width:320px" (ngSubmit)="submit()" [formGroup]="form">
    <h4 class="text-center mb-3">🔐 Login</h4>

    <div class="mb-2">
      <input class="form-control" formControlName="username" placeholder="Email" />
    </div>
    <div class="mb-3">
      <input class="form-control" type="password" formControlName="password" placeholder="Senha" />
    </div>

    <div *ngIf="error" class="alert alert-danger p-2">{{ error }}</div>

    <button class="btn btn-primary w-100" [disabled]="loading">
      {{ loading ? 'Entrando...' : 'Entrar' }}
    </button>
  </form>
</div>
